import client1 from './images/turbo-logo.jpg';
import client2 from './images/client2.png';
import client3 from './images/client3.png';
import client4 from './images/neiro-logo.jpg';
import client5 from './images/client5.png';
import { AnimatedTooltip } from 'components/ui/animated-tooltip';

const items = [
  {
    id: 1,
    name: 'Turbo',
    image: client1,
  },
  {
    id: 4,
    name: 'Neiro',
    image: client4,
  },
  {
    id: 2,
    name: 'Bobo',
    image: client2,
  },
  {
    id: 3,
    name: 'Sundog',
    image: client3,
  },
  {
    id: 5,
    name: 'Mumu',
    image: client5,
  },
];
export default function Component() {
  return (
    <div className="flex items-center rounded-full border border-border bg-background shadow shadow-black/5">
      <div className="flex w-fit -space-x-1.5">
        <AnimatedTooltip items={items} />
      </div>
    </div>
  );
}
